import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import arrow from '../../../../images/pcma-eve-arrow.svg';

export const Section = styled.div`
  display: flex;
  justify-content: center;
  background: ${({ $backgroundColor }) =>
    $backgroundColor ? themeGet(`colors.${$backgroundColor}`) : 'transparent'};
  background-image: url(${({ $backgroundImage }) =>
    $backgroundImage ? $backgroundImage.asset.localImage.publicURL : ''});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 3.5rem 0;
  margin: 40px auto;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 70px auto;
    padding: 4.5rem 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin: 100px auto;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${themeGet('media.grid')};
  width: calc(100% - ${themeGet('media.grid-gutter.2')});

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.4')});
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.5')});
  }
`;

export const Informations = styled.div`
  display: grid;
  grid-auto-flow: row;
  gap: 2.25rem;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    grid-auto-flow: column;
    grid-template-columns: repeat(3, 1fr [column]);
    gap: 2.25rem;
    padding: 0.75rem;
  }
`;

export const Info = styled.div`
  display: grid;
  grid-template-rows: subgrid;
  grid-row: auto / span 2;
  gap: 0.5rem;
  width: 100%;
`;

export const Header = styled.p`
  font-size: 1.5rem;
  font-weight: ${themeGet('fontWeights.medium')};
  line-height: 130%;
  color: ${({ theme, $headingColor }) =>
    $headingColor
      ? theme.colors[`${$headingColor}`]
      : theme.colors[`main-text`]};
  span.pc-arrow {
    position: relative;
    &:before {
      display: block;
      position: absolute;
      content: '';
      background-image: url(${arrow});
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      background-color: transparent;
      bottom: 0.5rem;
      left: -1rem;
      width: 6rem;
      height: 6rem;
      transform: rotate(12deg);

      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        bottom: -0.05rem;
        left: -4.5rem;
        width: 4.5rem;
        height: 4.5rem;
        transform: unset;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-size: 2.25rem;
    line-height: 150%;
  }
`;

export const BodyCopy = styled.p`
  font-size: 1rem;
`;
